export const startsWith = (options, query) => {
  return options.filter((item) => item.text.toLowerCase().startsWith(query.toLowerCase()));
};

export const getDropdownOptions = (list, valueField, textField) => {
  return list.map((item) => {
    return {'value': item[valueField], 'text': item[textField]};
  });
};
